import React from 'react';
import UsersList from '../components/users/UsersList';
import { useAuth } from '../context/AuthContext';

const UsersPage = () => {
  const { hasPermission } = useAuth();
  
  // Vérifier si l'utilisateur a la permission de gérer les utilisateurs
  if (!hasPermission('canManageUsers')) {
    return (
      <div className="flex flex-col items-center justify-center h-full p-4">
        <h2 className="text-2xl font-bold text-red-600 mb-4">Accès refusé</h2>
        <p className="text-gray-700 text-center">
          Vous n'avez pas les droits nécessaires pour accéder à cette page.
        </p>
      </div>
    );
  }
  
  return (
    <div className="container mx-auto py-6 px-4">
      <UsersList />
    </div>
  );
};

export default UsersPage;